import type { ContextMenuViewportRect } from './types/context-menu-viewport-rect'
/** Default width of editor context menu panels (`width: 288px`). */
export const CONTEXT_MENU_PANEL_WIDTH_PX = 288

/** Inset from the viewport edge so the menu does not touch rulers or scrollbars. */
export const CONTEXT_MENU_VIEWPORT_PADDING_PX = 8

/**
 * Place a context menu near `anchor` (cursor), flipping left and/or up when there is not enough
 * room in `viewport`, then clamping so the full panel stays visible.
 */
export function resolveContextMenuViewportPosition(
  anchorX: number,
  anchorY: number,
  menuWidth: number,
  menuHeight: number,
  viewport: ContextMenuViewportRect,
  padding = CONTEXT_MENU_VIEWPORT_PADDING_PX
): { left: number; top: number } {
  const menuW = Math.max(1, menuWidth)
  const menuH = Math.max(1, menuHeight)

  const minLeft = viewport.left + padding
  const minTop = viewport.top + padding
  const maxLeft = Math.max(minLeft, viewport.right - menuW - padding)
  const maxTop = Math.max(minTop, viewport.bottom - menuH - padding)

  let left = anchorX

  if (left + menuW + padding > viewport.right) {
    left = anchorX - menuW
  }

  left = Math.max(minLeft, Math.min(left, maxLeft))

  let top = anchorY

  if (top + menuH + padding > viewport.bottom) {
    top = anchorY - menuH
  }

  top = Math.max(minTop, Math.min(top, maxTop))

  return { left, top }
}

export function getWindowContextMenuViewport(): ContextMenuViewportRect {
  return {
    left: 0,
    top: 0,
    right: typeof window !== 'undefined' ? window.innerWidth : 0,
    bottom: typeof window !== 'undefined' ? window.innerHeight : 0,
  }
}
